module.exports = __webpack_public_path__ + "static/fonts/iconfont.18d191c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font-icons/iconfont.ttf?t=1494485609225
// module id = 1021
// module chunks = 1